import { render, staticRenderFns } from "./ScrollerItem.vue?vue&type=template&id=1d60d350&scoped=true&"
import script from "./ScrollerItem.vue?vue&type=script&lang=js&"
export * from "./ScrollerItem.vue?vue&type=script&lang=js&"
import style0 from "./ScrollerItem.vue?vue&type=style&index=0&id=1d60d350&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d60d350",
  null
  
)

export default component.exports